import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/tenant-finder-recommendations.png'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import { ShoppingCenterIcon } from 'src/components/insights/icons/shopping-center'

const TenantFinderRecommendations = dynamic(() => import('src/components/insights/tenant-finder-recommendations'), {
  ssr: false,
})

export const TenantFinderRecommendationsWidget: InsightBuilderWidget = {
  id: 'tenant-finder-recommendations',
  name: 'Tenant Finder Recommendations',
  type: 'Shopping Center Overview',
  icon: ShoppingCenterIcon,
  component: TenantFinderRecommendations,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
